import { render, staticRenderFns } from "./EmployeeIndex.vue?vue&type=template&id=4ca5c63e&scoped=true&"
import script from "./EmployeeIndex.vue?vue&type=script&lang=js&"
export * from "./EmployeeIndex.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeIndex.vue?vue&type=style&index=0&id=4ca5c63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5c63e",
  null
  
)

export default component.exports